module.exports = __webpack_public_path__ + "public/1e659942089063d2a03e32e40de362a6.svg";